import DtvTheme from "@directv-digital/dds.ui.dtv-theme";
import { focusVisibleOutline } from "@/ChnlListingPageV2/utils/focusVisibleOutline";

const bps = DtvTheme.breakpoints;

export const stickyHeaderStyles = {
  position: "sticky",
  top: '0px',
  left: 0
}

export const channelColWidthStyle = {
  flexBasis: "215px !important",
  maxWidth: "215px !important",
  minWidth: "215px !important",
  [bps.down(bps.values.md)]: {
    flexBasis: "150px !important",
    maxWidth: "150px !important",
    minWidth: "150px !important"
  },
  [bps.down(bps.values.sm)]: {
    flexBasis: "130px !important",
    maxWidth: "130px !important",
    minWidth: "130px !important"
  },
  [bps.down(350)]: {
    flexBasis: "110px !important",
    maxWidth: "110px !important",
    minWidth: "110px !important"
  }
};

/**
 * @important !!
 * @description Styles which can be rendered hassle free on the server side.
 * Styles do not depend on Typescript variables (except media queries from theme), therefore
 * they always render content THE SAME before and after hydration (i.e., no layout shift)
 */
export const ssrStyles = {
  tableRootContainer: {
    padding: "20px 0",
    margin: "0px",
    position: "relative",
    transition: "all 0.2s ease-in-out",
    [bps.between(bps.values.sm, bps.values.md)]: {
      padding: "32px 0 !important",
      margin: "0px 40px !important"
    },
    [bps.between(bps.values.md, bps.values.lg)]: {
      padding: "48px 0 !important",
      margin: "0px 64px !important"
    },
    [bps.up(bps.values.lg)]: {
      padding: "48px 0 !important",
      margin: "0px 80px !important"
    }
  },
  tablerowContainer: {
    display: "flex",
    paddingTop: "0px !important",
    paddingBottom: "8px !important",
    border: "none",
    alignItems: "stretch"
  },

  header: {
    sortContainer: {
      display: "flex",
      justifyContent: "flex-start !important",
      alignItems: "center !important",
      padding: "5px 3px 0px 3px",
      fontSize: "14px",
      [bps.down(bps.values.sm)]: {
        paddingBottom: "4px !important"
      }
    },
    sortPaper: {
      backgroundColor: "transparent !important",
      transition: "background-color 300ms ease-in-out",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      padding: "8px !important",
      textAlign: "center"
    },
    radioButtonOverrides: {
      "& .MuiFormGroup-root": {
        // each item
        "& label": {
          margin: "0 0 12px 0 !important",
          "&:last-child": { margin: "0 !important" },
          "& span": {
            textAlign: "left !important",
            "&:first-child": {
              [bps.down(bps.values.md)]: {
                height: "24px !important",
                width: "24px !important"
              }
            }
          },
          [bps.up(1200)]: {
            "& .MuiFormControlLabel-label": {
              fontSize: "20px !important"
            }
          }
        }
      }
    },
    packageFontStyles: {
      fontFamily: "roboto-medium",
      fontWeight: 500,
      // transition happens around 850px.
      // Attempt to cover most scenarios with ssr (i.e., no layout shift)
      // vertHeaders then update if needed on first paint
      [bps.down(850)]: {
        flexDirection: "column !important",
        writingMode: "vertical-rl ",
        textOrientation: "mixed",
        transform: "rotate(180deg)",
        marginTop: "8px 0 0 0",
        height: "140px"
      },
      "@supports (-webkit-touch-callout: none)": {
        "@media screen and (max-width: 600px) and (hover: none) and (pointer: coarse)": {
          height: "155px"
        }
      }
    },
    shopBtnContainer: {
      width: "100%",
      justifyContent: "center",
      padding: "10px 5% 0px 5%",
      [bps.between(bps.values.sm, bps.values.md)]: {
        padding: "12px 0 0 0"
      },
      [bps.up(bps.values.md)]: {
        padding: "16px 0 0 0"
      }
    },
    shopBtn: {
      fontFamily: "roboto-medium",
      fontWeight: 500,
      lineHeight: "0",
      textTransform: "inherit",
      textWrap: "nowrap",
      fontSize: "14px",
      borderRadius: "100px",
      width: "100%",
      maxWidth: "100%",
      height: "26px !important",
      margin: "0px !important",
      padding: "20px 0px",
      // [WAT-12043 / YFH-AMP108] uxprimary variant in dds.ui.dtv-theme has no
      // :focus-visible outline; add one here to satisfy WCAG 2.4.7 without
      // waiting on the DDS-side fix. Ring token + selector rules live in
      // utils/focusVisibleOutline (shared with CategoryHeader / Footer /
      // ChannelRow / SvodChannelRow to keep the seven prior copies in sync).
      ...focusVisibleOutline("&.Mui-focusVisible", "-2px"),
      [bps.down(bps.values.sm)]: {
        maxWidth: "95%",
        minWidth: "95%",
        padding: "15px 0px"
      },
      [bps.down(400)]: {
        fontSize: "12px"
      }
    }
  },
  grid: {
    myFreeDtvContainer: {
      display: "flex",
      width: "100%",
      margin: "0px !important",
      padding: "0 0 8px 0 !important",
      borderLeft: "none",
      borderRight: "none",
      [bps.up(bps.values.md)]: {
        alignItems: "flex-end"
      }
    },
    muiAccordion: {
      backgroundColor: "transparent !important"
    },
    muiAccordionDetails: {
      padding: "0px",
      margin: "0px",
      maxWidth: "100% !important",
      fontFamily: "roboto-regular"
    },
    accTableOverride: {
      width: "100%",
      border: 'none',
      borderSpacing: 'unset'
    },
    tdFullWidthOverride: {
      width: '100%',
      padding: '0 !important',
      border: 'none'
    }
  }
};
